import { createFileRoute } from "@tanstack/react-router";

import UsdaAuditFeedback from "~/pages/UsdaAuditFeedback";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/usda-audit-feedback")({
  staticData: ROUTE_STATIC.usdaAuditFeedback,
  component: UsdaAuditFeedback,
});
